export const APP_VERSION = '1.71.0';
